import React from "react";
import styles from "../styles/Spinner.module.scss";

//Generic loading logo with animation
export default function Spinner({ isLoading, spinnerStyle, ...props }) {
  return (
    <>
      {isLoading && (
        <img
          alt="loading"
          src="https://frontend-assets.buildbox.com/Icon_Loading.svg"
          className={styles.spinner}
        />
      )}
    </>
  );
}
